import {Tooltip} from 'platform/components';
import {HStack, Text, ThemeColorTextPath} from 'platform/foundation';
import {match, Pattern} from 'ts-pattern';

import {always} from 'ramda';

import {useMemoryUsage} from '../../../hooks/useMemoryUsage';
import {getFixedTranslation} from '../../../utils/getFixedTranslation';

export function MemoryUsage() {
  const memoryStats = useMemoryUsage();

  const memoryColor = match<number, ThemeColorTextPath>(memoryStats.usagePercentage)
    .with(Pattern.number.gte(80), always('danger'))
    .with(Pattern.number.gte(60), always('warning'))
    .otherwise(always('success'));

  return (
    <Tooltip label={getFixedTranslation('page.settings.labels.memoryUsage')}>
      <HStack spacing={1}>
        <Text color={memoryColor}>{memoryStats.usedMemoryMB}</Text>
        <Text color="tertiary">MB</Text>
        <Text color="tertiary">({memoryStats.usagePercentage}%)</Text>
      </HStack>
    </Tooltip>
  );
}
